import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useRecoilState } from 'recoil';
import { DialogMessageState } from '../../recoil/states';

const DialogMessage = () => {

    const [dialogMessageState, setDialogMessageState] = useRecoilState(DialogMessageState); // 다일얼로그 메세지 요청 정보를 갖는 state

    /**
     * 확인 버튼 클릭 이벤트
     * @param e 이벤트 객체
     * @param btnType 버튼 유형 (확인 : OK / 취소 : CANCEL)
     */
    const handlerDialogBtn = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, btnType: string) => {

        if (btnType === "OK") {
            if(typeof dialogMessageState.callbackFuncOk === "function") {

                // 콜백함수를 실시간으로 실행하면, 렌더링 타이밍 때문인지 UI 제어(focus, blur 등..)가 안되는 경우가 있어서 일정시간 이후 콜백 호출해줘야 함!
                const _callbackFuncOk = dialogMessageState.callbackFuncOk;
                setTimeout(() => {
                    _callbackFuncOk();
                }, 100);
            }
        }
        else if (btnType === "CANCEL") {
            if(typeof dialogMessageState.callbackFuncCancel === "function") {

                // 콜백함수를 실시간으로 실행하면, 렌더링 타이밍 때문인지 UI 제어(focus, blur 등..)가 안되는 경우가 있어서 일정시간 이후 콜백 호출해줘야 함!
                const _callbackFuncCancel = dialogMessageState.callbackFuncCancel;
                setTimeout(() => {
                    _callbackFuncCancel();
                }, 100);
            }
        }
        setDialogMessageState(rawState => ({...rawState, isShow: false, callbackFuncOk: undefined, callbackFuncCancel: undefined})); // 다일얼로그 메세지 요청 정보 state 초기화 요청
    }

    return (
        <Dialog open={dialogMessageState.isShow}>
            <DialogTitle>{dialogMessageState.title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{dialogMessageState.message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => handlerDialogBtn(e, "OK")}>확인</Button>
                {dialogMessageState.isConfirm && <Button variant="outlined" onClick={e => handlerDialogBtn(e, "CANCEL")}>취소</Button>}
            </DialogActions>
        </Dialog>
    )
}

export default DialogMessage;
